const _excluded = ["layout", "eyebrowLabel", "title", "description", "longDescription", "ctaLabel", "ctaUrl", "ctaType", "hasArrow", "style"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useMemo } from 'react';
import styled from 'styled-components';
import { palette } from '@cbhq/cds-web/tokens';
import { componentsThemeMap } from '../../componentsThemeMap.js';
import '../../ui/Div/index.js';
import { LinkPressable } from '../../ui/Link/LinkPressable.js';
import '../../ui/LinkArrow/index.js';
import { Text } from '../../ui/Text.js';
import { CardIllustrationIcon } from './CardIllustrationIcon.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Div } from '../../ui/Div/Div.js';
import { LinkArrow } from '../../ui/LinkArrow/LinkArrow.js';
const customComponentThemeMap = {
  default: _objectSpread(_objectSpread({}, componentsThemeMap.default), {}, {
    elevation: 1
  }),
  dark: {
    background: 'gray80',
    foreground: 'background',
    foregroundSecondary: 'background',
    elevation: 0
  },
  subtle: _objectSpread(_objectSpread({}, componentsThemeMap.subtle), {}, {
    elevation: 0,
    background: 'background'
  }),
  wash: _objectSpread(_objectSpread({}, componentsThemeMap.subtle), {}, {
    elevation: 0,
    background: 'background'
  }),
  darkwash: {
    background: 'gray80',
    foreground: 'background',
    foregroundSecondary: 'background',
    elevation: 0
  },
  primary: {
    elevation: 0,
    background: 'background',
    foreground: 'foreground',
    foregroundSecondary: 'foreground'
  }
};
function CardIllustration(_ref) {
  let _ref$layout = _ref.layout,
    layout = _ref$layout === void 0 ? 'vertical' : _ref$layout,
    eyebrowLabel = _ref.eyebrowLabel,
    title = _ref.title,
    description = _ref.description,
    longDescription = _ref.longDescription,
    ctaLabel = _ref.ctaLabel,
    ctaUrl = _ref.ctaUrl,
    ctaType = _ref.ctaType,
    _ref$hasArrow = _ref.hasArrow,
    hasArrow = _ref$hasArrow === void 0 ? false : _ref$hasArrow,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? 'default' : _ref$style,
    iconProps = _objectWithoutProperties(_ref, _excluded);
  const isCardCta = Boolean(ctaUrl);
  const isVertical = layout === 'vertical';
  const showIcon = iconProps?.icon || iconProps?.pictogram || iconProps?.imageUrl;
  const LinkWrapper = useMemo(() => {
    if (!ctaUrl || hasArrow) {
      // eslint-disable-next-line no-inner-declarations -- TODO Fix this
      function Wrapper({
        children
      }) {
        return /*#__PURE__*/jsx(Div, {
          as: "div",
          children: children
        });
      }
      return Wrapper;
    } else {
      // eslint-disable-next-line no-inner-declarations -- TODO Fix this
      function Link({
        children
      }) {
        return /*#__PURE__*/jsx(LinkPressable, {
          href: ctaUrl,
          children: children
        });
      }
      return Link;
    }
  }, [ctaUrl, hasArrow]);
  const _customComponentTheme = customComponentThemeMap[style],
    elevation = _customComponentTheme.elevation,
    background = _customComponentTheme.background,
    foreground = _customComponentTheme.foreground,
    foregroundSecondary = _customComponentTheme.foregroundSecondary;
  return (/*#__PURE__*/
    // eslint-disable-next-line @cbhq/react-no-nested-component -- TODO Fix this
    jsx(LinkWrapper, {
      children: /*#__PURE__*/jsx(Div, {
        height: "100%",
        width: "100%",
        children: /*#__PURE__*/jsxs(CardContainer, {
          flexDirection: isVertical ? 'column' : 'row',
          gap: isVertical ? 3 : 6,
          background: background,
          elevation: elevation,
          spacing: isCardCta ? 4 : {
            sm: 2,
            md: 5
          },
          borderRadius: "roundedSmall",
          minHeight: isVertical ? isCardCta ? 256 : {
            sm: 150,
            md: 300
          } : 'none',
          height: isVertical ? '100%' : 'unset',
          width: "100%",
          $hasAnimation: Boolean(ctaUrl && !hasArrow),
          children: [showIcon && /*#__PURE__*/jsx(CardIllustrationIcon, _objectSpread(_objectSpread({}, iconProps), {}, {
            maxWidth: !isVertical ? 80 : 'unset',
            height: isVertical && isCardCta ? iconProps.icon ? 24 : 48 : 80,
            iconColor: foreground
          })), /*#__PURE__*/jsxs(Div, {
            flexDirection: "column",
            flex: 1,
            children: [/*#__PURE__*/jsx(StyledTitle, {
              content: eyebrowLabel,
              children: /*#__PURE__*/jsx(Text, {
                as: "span",
                color: foreground,
                variant: !isVertical ? 'headline' : {
                  sm: 'title4',
                  md: isCardCta ? 'title4' : 'title2'
                },
                children: title
              })
            }), /*#__PURE__*/jsx(Text, {
              as: "p",
              variant: !isVertical ? 'body' : {
                sm: 'label2',
                md: isCardCta ? 'label2' : 'body'
              },
              spacingTop: 1,
              color: foregroundSecondary,
              children: description ? description : longDescription
            })]
          }), ctaUrl && hasArrow && /*#__PURE__*/jsx(LinkArrow, {
            ctaType: ctaType,
            ctaUrl: ctaUrl,
            children: ctaLabel
          })]
        })
      })
    })
  );
}
const CardContainer = styled(Div)`
  ${({
  $hasAnimation
}) => $hasAnimation && `
      &:hover {
        transition: transform .3s;
        transform: scale(1.01);
      }
  `}
`;
const StyledTitle = styled.div.withConfig({
  shouldForwardProp: p => !['content'].includes(p)
}).attrs(p => ({
  style: p.content ? {
    '--card-illustration-title-content': `'${p.content.replace(/'/g, "\\'")}'`
  } : {}
}))`
  ${({
  content
}) => content ? `> span:after {
    content: var(--card-illustration-title-content);
    display: flex;
    align-items: center;
    font-size: 10px;
    font-weight: 500;
    line-height: 24px;
    border-radius: 10px;
    white-space: nowrap;
    height: 15px;
    padding: 0 6px;
    margin-left: 8px;
    background: ${palette.primary};
    color: ${palette.background};
  }` : ''}
`;
export { CardIllustration };
//# sourceMappingURL=CardIllustration.js.map
